import React from "react";
import ReactDOM from "react-dom/client";
// Init Sentry le plus tot possible (l'import execute config/sentry.js -> Sentry.init).
import { captureToSentry } from "./config/sentry";
import "./index.css";
import App from "./App";
import { SnackbarProvider } from "notistack";

import { BrowserRouter as Router } from "react-router-dom";
import CustomSnackbar from "./notification/NotificationStyle";
import { AppProvider } from "./config/AppContext";

// Capture globale des erreurs JS / rejets de promesse non geres vers le projet
// Sentry hexagone-front (Sentry.init pose deja ses handlers, ceci ajoute un
// contexte explicite et couvre le cas ou l'init auto serait insuffisante).
if (typeof window !== "undefined") {
  window.addEventListener("error", (event) => {
    captureToSentry(event.error || event.message, {
      tags: { source: "window.onerror" },
    });
  });
  window.addEventListener("unhandledrejection", (event) => {
    captureToSentry(event.reason || "Unhandled promise rejection", {
      tags: { source: "unhandledrejection" },
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <SnackbarProvider
        maxSnack={8} // Wrap App with SnackbarProvider
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }} // Customize position
        autoHideDuration={6000}
        Components={{
          success: CustomSnackbar,
          error: CustomSnackbar,
        }}
      >
        <Router>
          <App />
        </Router>
      </SnackbarProvider>
    </AppProvider>
  </React.StrictMode>
);
